





















import { useVModel } from '@vueuse/core';
import { computed, defineComponent, PropType, ref } from '@vue/composition-api';

import { IWorkflowStateThresholdGroup } from '@/models';

import { VAutocomplete } from 'vuetify/lib/components';
import { useFetchThresholdGroups } from '@/composable/useWorkflowStateThresholdGroup';
import { useWorkflowStateThresholdGroup } from './composables/useWorkflowStateThresholdGroup';

export default defineComponent({
  name: 'WorkflowStateThresholdGroupAutoPicker',

  props: {
    value: [Array, Number, Object] as PropType<
      | IWorkflowStateThresholdGroup
      | number
      | (IWorkflowStateThresholdGroup | number)[]
      | null
    >,

    errorMessages: {
      type: [String, Array] as PropType<string | string[]>
    },

    itemText: {
      type: [String, Function] as PropType<string | ((item: any) => string)>,
      default: 'toString()'
    }
  },

  setup(props) {
    const thresholdGroupContext = useWorkflowStateThresholdGroup();

    const groupVModel = useVModel(props);

    const errorMessageList = computed(() => {
      let errorList: string[] = [];

      if (thresholdGroupsError.value) {
        errorList.push(thresholdGroupsError.value.message);
      }
      if (props.errorMessages) {
        if (Array.isArray(props.errorMessages)) {
          errorList.push(...props.errorMessages);
        } else {
          errorList.push(props.errorMessages);
        }
      }

      return errorList;
    });

    const {
      thresholdGroups,
      isLoadingThresholdGroups,
      thresholdGroupsError
    } = useFetchThresholdGroups(
      thresholdGroupContext.workflowId.value,
      thresholdGroupContext.workflowStateId.value
    );

    /** @public */
    const autocompleteRef = ref<
      InstanceType<typeof VAutocomplete> & { reset: () => void }
    >();

    /** @public */
    function reset() {
      if (autocompleteRef.value) autocompleteRef.value.reset();
    }

    return {
      reset,
      autocompleteRef,
      thresholdGroups,
      groupVModel,
      isLoadingThresholdGroups,
      errorMessageList
    };
  }
});
